angular.module('animatronApp.settings').directive('upgradePlan', () => {
    return (_: any, $rootScope: ng.IRootScopeService) => {
        $rootScope.coupon = {};
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/upgradePlanDirective.ts